import { HeadingTags, defaultHeadingTag } from '@primer/react-brand';
import { Box as Container } from '@primer/react';
import { ColorThemePicker } from "../../../../src/components/content/ColorThemePicker";
import { ColorScales } from "../../../../src/components";
import * as React from 'react';
export default {
  HeadingTags,
  defaultHeadingTag,
  Container,
  ColorThemePicker,
  ColorScales,
  React
};